module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Text/Bullet-list-5f8c168fb030a8c2647f16aa1a21dfd5.svg";